var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"contents"}},[_c('v-progress-linear',{staticClass:"z-index-100",attrs:{"active":_vm.progressBar,"color":_vm.color,"absolute":"","top":"","height":"3","value":_vm.initProgress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }